import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Table } from 'antd';

import PaymentDetailsModal from 'components/modal/PaymentDetailsModal';
import UnsubscribeModal from 'components/modal/UnsubscribeModal';
import DefaultButton from 'components/button/DefaultButton';
import Paginav from 'components/paginav/Pagination';

import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import ReSubScribeModal from 'components/modal/ReSubScribeModal';
import { MembershipDetailscolumns } from 'consts/table';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys, restfetcher } from 'queryClient';
import { handleDate } from 'utils/date';
import { getSubScribeStatus, getSubscriptionType } from 'utils/common';
import companyInforAtom from 'atom/companyInfoAtom';
import userInforAtom from 'atom/userInfoAtom';
import { useAtomValue } from 'jotai';

interface MembershipDetailTableProps {
  registeredCard: { cardname: string; cardnumber: string };
}

const MembershipDetailTable = ({ registeredCard }: MembershipDetailTableProps) => {
  const pageSize = 5;
  const [pageNumber, setPageNumber] = useState(0);

  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [isUnsubscribeModalOpen, setIsUnsubscribeModalOpen] = useState(false);
  const [isResubscribeModalOpen, setIsResubscribeModalOpen] = useState(false);

  const [isReSubScribeData, setIsReSubScribeData] = useState({
    subscribeid: '',
    programidx: 0,
    subscribeType: 0,
    price: 0,
    currency: '',
    ticketName: ''
  });

  const userInfor = useAtomValue(userInforAtom);
  const companyInfor = useAtomValue(companyInforAtom);

  const handlePageChange = (page: number) => {
    setPageNumber(page);
  };

  const handleClickOpenPayListModal = () => {
    setIsDetailModalOpen(true);
  };

  const handleClickClosePayListModal = () => {
    setIsDetailModalOpen(false);
  };

  const handleOpenUnsubScribeModal = (subScribeData: MembershipSubScribeListInfo) => {
    const { subscribeid, programidx, subscribeType, price, currency, ticketName } = subScribeData;

    setIsReSubScribeData({
      subscribeid: subscribeid,
      programidx: programidx,
      subscribeType: subscribeType,
      price: Number(price),
      currency: currency,
      ticketName: ticketName
    });

    setIsUnsubscribeModalOpen(true);
  };

  const handleCloseUnsubScribeModal = () => {
    setIsUnsubscribeModalOpen(false);
  };

  const handleOpenReSubScribeModal = (subScribeData: MembershipSubScribeListInfo) => {
    const { subscribeid, programidx, subscribeType, price, currency, ticketName } = subScribeData;

    setIsReSubScribeData({
      subscribeid: subscribeid,
      programidx: programidx,
      subscribeType: subscribeType,
      price: Number(price),
      currency: currency,
      ticketName: ticketName
    });
    setIsResubscribeModalOpen(true);
  };

  const handleCloseReSubScribeModal = () => {
    setIsResubscribeModalOpen(false);
  };

  const requestMembershipSubscribeList = useQuery({
    queryKey: [QueryKeys.MEMBERSHIP_SUBSCRIBE_DETAIL],
    queryFn: () =>
      restfetcher({
        method: 'POST',
        path: 'biz/my/membership/subscribe/list',
        params: {
          // usridx: 249,
          // companyidx: 291,
          usridx: userInfor.usridx,
          companyidx: companyInfor.companyidx,
          page: pageNumber,
          size: pageSize
        }
      })
  });

  const subScribeList: MembershipSubScribeListInfo[] =
    requestMembershipSubscribeList?.data?.data?.list || [];

  const totalElements = requestMembershipSubscribeList?.data?.data?.totalElements;
  const totalPages = requestMembershipSubscribeList?.data?.data?.totalPages;

  const divisionDataList = requestMembershipSubscribeList?.data?.division;

  const getValueByKey = (key: number): string | undefined => {
    return divisionDataList[key];
  };

  const membershipSubScribeData = subScribeList?.map(
    (subScribeData: MembershipSubScribeListInfo) => {
      const {
        programidx,
        subscribeid,
        ticketName,
        divisions,
        subscribeType,
        price,
        currency,
        subscribeStatus,
        date,
        resultMsg
      } = subScribeData;

      return {
        key: subscribeid,
        membership: ticketName,
        details:
          divisions.length > 0 ? (
            <div className="membership-details">
              <h6>기본이용권</h6>
              <h6>검사이용권</h6>
              <div className="division-wrapper">
                {divisions.map((division, index) => (
                  <p key={index} className="division">
                    {getValueByKey(division)}
                  </p>
                ))}
              </div>
            </div>
          ) : (
            <div className="membership-details">
              <h6>기본이용권</h6>
            </div>
          ),
        price: (
          <ManageTextWrapper>
            <div>{getSubscriptionType(subscribeType)}</div>
            <div>{Number(price).toLocaleString()}원</div>
          </ManageTextWrapper>
        ),
        status: (
          <pre>
            {getSubScribeStatus(subscribeStatus)}
            <br />
            <p className="date">({handleDate(date, true)})</p>
          </pre>
        ),
        manage: (
          //
          <ButtonWrapper>
            {(subscribeStatus === 'STOPSUBSCRIBE' ||
              (subscribeStatus === 'STOPSUBSCRIBE' && subscribeType !== 5)) && (
              <DefaultButton
                onClick={() => handleOpenReSubScribeModal(subScribeData)}
                text="재결제"
                size="small"
                type="primary"
              />
            )}

            {subscribeStatus !== 'UNSUBSCRIBE' && (
              <div className="unsubscribe">
                <DefaultButton
                  onClick={() => handleOpenUnsubScribeModal(subScribeData)}
                  text="멤버십해지"
                  size="small"
                  type="primary"
                />
              </div>
            )}
          </ButtonWrapper>
        )
      };
    }
  );

  useEffect(() => {
    if (userInfor.usridx !== 0) {
      requestMembershipSubscribeList.refetch();
    }
  }, [pageNumber, userInfor.usridx]);

  return (
    <>
      <Wrapper>
        <h2>비즈멤버십 구독내역</h2>
        <DefaultButton onClick={handleClickOpenPayListModal} text="결제내역" size="small" />
      </Wrapper>
      <PaymentDetails>
        <Table
          dataSource={membershipSubScribeData}
          bordered
          columns={MembershipDetailscolumns}
          pagination={false}
        />
      </PaymentDetails>
      {totalPages > 1 && (
        <PaginationWrapper>
          <Paginav
            total={totalElements}
            pageSize={pageSize}
            currentPage={pageNumber}
            onPageChange={handlePageChange}
          />
        </PaginationWrapper>
      )}

      {isDetailModalOpen && (
        <PaymentDetailsModal open={isDetailModalOpen} onCancel={handleClickClosePayListModal} />
      )}
      {isUnsubscribeModalOpen && (
        <UnsubscribeModal
          open={isUnsubscribeModalOpen}
          unSubScribeData={isReSubScribeData}
          onCancel={handleCloseUnsubScribeModal}
        />
      )}
      {isResubscribeModalOpen && (
        <ReSubScribeModal
          open={isResubscribeModalOpen}
          registeredCard={registeredCard}
          reSubScribeData={isReSubScribeData}
          onCancel={handleCloseReSubScribeModal}
        />
      )}
    </>
  );
};

export default MembershipDetailTable;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;

  & p button.ant-btn-round.ant-btn-default.ant-btn-sm {
    color: ${color.black2};
    border-color: ${color.black2};
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;

  & div.unsubscribe p button {
    background-color: ${color.gray500} !important;
  }
`;

const PaymentDetails = styled.div`
  tbody tr {
    text-align: center;

    td {
      vertical-align: middle;

      & div.membership-details {
        text-align: left;

        h6 {
          display: flex;
          align-items: center;
          gap: 8px;

          &:before {
            display: inline-block;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background: ${color.black2};
            content: '';
          }
        }

        .division-wrapper {
          position: relative;
          padding-left: 14px;
          color: ${color.gray600};
          ${font.caption2_regular};

          &::before,
          &::after {
            content: '';
            position: absolute;
            left: 1px;
            top: 50%;
            bottom: 0;
            transform: translateY(-50%);
            width: 2px;
            height: 95%;
            background-color: ${color.gray200};
          }
        }
      }
    }
  }

  p.date {
    color: ${color.gray600};
    ${font.caption3_regular};
  }
`;

const PaginationWrapper = styled.div`
  margin: 24px 0 48px;
  display: flex;
  justify-content: end;
`;

const ManageTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 4px;
`;
